import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';

const CampusContext = createContext(null);
const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const CampusProvider = ({ children }) => {
  const { token, isAuthenticated } = useAuth();
  const [campuses, setCampuses] = useState([]);
  const [selectedCampus, setSelectedCampus] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchCampuses = async () => {
    if (!token) {
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const response = await axios.get(`${API_URL}/campuses`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCampuses(response.data);
    } catch (error) {
      console.error('Error fetching campuses:', error);
      setCampuses([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isAuthenticated && token) {
      fetchCampuses();
    } else if (!isAuthenticated) {
      setCampuses([]);
      setLoading(false);
    }
  }, [token, isAuthenticated]);

  const getCampusById = (id) => campuses.find(c => c.id === id);

  return (
    <CampusContext.Provider value={{
      selectedCampus,
      setSelectedCampus,
      campuses,
      getCampusById,
      loading,
      refreshCampuses: fetchCampuses
    }}>
      {children}
    </CampusContext.Provider>
  );
};

export const useCampus = () => {
  const context = useContext(CampusContext);
  if (!context) {
    throw new Error('useCampus must be used within a CampusProvider');
  }
  return context;
};
